import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdcRoute extends Route {
    @service urlData;
    @service router;

    model(params) {
        this.set('urlData.adc', params.adc);
        this.router.transitionTo('index');
    }
}
